import useDialog from './useDialog';

const styles = `
.hpp-loading .hpp-dialog__mask {
  background: rgba(255, 255, 255, 0.9);
}

.hpp-loading__container {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.hpp-loading__text {
  margin: 3px 0;
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
  line-height: 20px;
}

.hpp-loading__icon {
  width: 40px;
  height: 40px;
}

.hpp-loading__icon div {
  display: inline-block;
  width: 3px;
  height: 12px;
  margin-left: 6px;
  margin-top: 14px;
  transform: skew(-8deg);
  background-color: ${process.env.brandColor};
  animation: strechdelay 1.5s infinite ease-in-out;
}

.hpp-loading__icon .line1 {
  margin-left: 0;
}

.hpp-loading__icon .line2 {
  animation-delay: 0.2s;
}

.hpp-loading__icon .line3 {
  animation-delay: 0.4s;
}

.hpp-loading__icon .line4 {
  animation-delay: 0.6s;
}

@keyframes strechdelay {
  20%,
  80% {
    transform: scaleX(1) scaleY(1) skew(-8deg);
    opacity: 0.3;
  }

  0%,
  100% {
    transform: scaleX(1) scaleY(1) skew(-8deg);
    opacity: 0.3;
  }

  50% {
    transform: scaleX(1.8) scaleY(1.6) skew(-8deg);
    opacity: 1;
  }
}
`;
const elStyle = document.createElement('style');
elStyle.innerHTML = styles;
document.head.appendChild(elStyle);

/**
 * @param {HTMLElement} target
 * @param {{text: string}} config
 */
function useLoading(target, config = {}) {
  const elLoadingContainer = document.createElement('div');
  elLoadingContainer.classList.add('hpp-loading__container');
  const loading = useDialog(elLoadingContainer, { destroyOnClose: true });
  loading.el.classList.add('hpp-loading');

  const elLoadingIcon = document.createElement('div');
  elLoadingIcon.classList.add('hpp-loading__icon');
  elLoadingContainer.appendChild(elLoadingIcon);
  const elLoadingLine1 = document.createElement('div');
  const elLoadingLine2 = document.createElement('div');
  const elLoadingLine3 = document.createElement('div');
  const elLoadingLine4 = document.createElement('div');
  elLoadingLine1.className = 'line1';
  elLoadingLine2.className = 'line2';
  elLoadingLine3.className = 'line3';
  elLoadingLine4.className = 'line4';
  elLoadingIcon.appendChild(elLoadingLine1);
  elLoadingIcon.appendChild(elLoadingLine2);
  elLoadingIcon.appendChild(elLoadingLine3);
  elLoadingIcon.appendChild(elLoadingLine4);

  if (config?.text) {
    const elLoadingParagraph = document.createElement('p');
    elLoadingParagraph.classList.add('hpp-loading__text');
    elLoadingContainer.appendChild(elLoadingParagraph);
    elLoadingParagraph.textContent = config.text;
  }

  if (target) {
    target.appendChild(loading.el);
    target.style.position = 'relative';
    loading.el.style.position = 'absolute';
  } else {
    loading.open();
  }

  return {
    close: loading.close
  };
}

export default useLoading;
